<script setup lang="ts">
definePage({
  path: '/tools/JobFunctionSuggestions',
  name: '/tools/JobFunctionSuggestions',
  meta: {
    title: 'Functiesuggesties testen',
    permission: {
      resource: 'JobFunctions',
      level: 'Read',
    },
  },
})

const route = useRoute()
const router = useRouter()

function parseFunctionIds(value: unknown): number[] {
  const serialized = Array.isArray(value) ? value[0] : value
  if (typeof serialized !== 'string') {
    return []
  }

  return [
    ...new Set(serialized
      .split(',')
      .map(Number)
      .filter(id => Number.isSafeInteger(id) && id > 0)), 
  ]
}

const selectedJobFunctionIds = ref(parseFunctionIds(route.query.functions))

watch(selectedJobFunctionIds, (ids) => {
  router.replace({
    query: {
      ...route.query,
      functions: ids.length ? ids.join(',') : undefined,
    },
  })
}, { deep: true })
</script>

<template>
  <!--
  THESIS: Make co-selection behavior inspectable; refuse a decorative dashboard.
  OWN-WORLD: Command Navy actions, neutral PrimeVue surfaces, compact tabular evidence.
  STORY: Select functions, run the calculation, judge suggestions against cohort and job counts.
  FIRST VIEWPORT: One focused work surface with the selector above a five-row evidence table.
  FORM: Existing Precision Instrument admin form; narrow extension, seed narrow-existing-surface.
  FINISH: unreviewed and undocumented is unfinished; this build ends with the finish review, the verdict, DESIGN.md, and every shipping raster carrying its provenance
  -->
  <Card>
    <template #content>
      <div class="mb-5 max-w-3xl">
        <h3 class="mb-2">
          Functiesuggesties testen
        </h3>
        <p class="m-0 text-sm text-surface-600 leading-relaxed">
          Bekijk welke aanvullende functies voorkomen bij vergelijkbare kandidaten. Alleen functies
          waaraan vacatures gekoppeld zijn worden getoond.
        </p>
      </div>

      <JobFunctionSuggestionPanel
        v-model="selectedJobFunctionIds"
        editable
      />
    </template>
  </Card>
</template>
